<template>
  <div class="row myrow content-mb-42" v-if="$parent.$parent.rerender">
    <table class="c-indicator c-indicator-w-100">
      <thead>
        <tr>
          <th class="tab-wid-80">№<br /></th>
          <th class="tab-wid-250">Наименование предмета лизинга</th>
          <th class="tab-wid-250">Фирма-производитель</th>
          <th class="tab-wid-250">Страна происхождения</th>
          <th class="tab-wid-250">
            Заводской или иной идентификационный номер
          </th>
          <th class="tab-wid-250">Количество</th>
          <th class="tab-wid-250">Цена за единицу, руб., в том числе НДС</th>
          <th class="tab-wid-250">Общая цена, руб., в том числе НДС</th>
          <th class="tab-wid-80"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in $parent.project.EQUIPMENT_BUY_LIZING.items">
          <td class="tab-wid-80">{{ index + 1 }}</td>
          <td class="tab-wid-80">{{ item.UF_NAME }}</td>
          <td class="tab-wid-80">{{ item.UF_FIRM_MANUFACTURER }}</td>
          <td class="tab-wid-80">
            {{ countryName(item.UF_COUNTRY_ORIGIN_ID) }}
          </td>
          <td class="tab-wid-80">{{ item.UF_FACTORY_IDENTIFICATION_NUMB }}</td>
          <td class="tab-wid-80">{{ item.UF_COUNT }}</td>
          <td class="tab-wid-80">{{ item.UF_PRICE_UNIT }}</td>
          <td class="tab-wid-80">
            {{ (item.UF_COUNT * item.UF_PRICE_UNIT) | toCurrency }}
          </td>
          <td
            v-if="
              !$parent.$parent.projectDisabled &&
                !$parent.project.UF_IS_BLOCK &&
                $parent.project.UF_SETTING.IS_EQUIPMENT_ACCEPT !== 1
            "
          >
            <i class="i-edit centerIcon" @click="editItem(index)"></i>
            <i
              class="i-delete centerIcon"
              title="Удалить запись"
              @click="deleteItem(index)"
            ></i>
          </td>
        </tr>
      </tbody>
    </table>
    <br />
    <div
      class="add-row"
      v-show="
        !$parent.$parent.projectDisabled &&
          !$parent.project.UF_IS_BLOCK &&
          $parent.project.UF_SETTING.IS_EQUIPMENT_ACCEPT !== 1
      "
    >
      <a class="link-add-row" @click="showAddItem">Добавить</a>
    </div>
    <div
      class="modal fade in"
      v-bind:class="{ show: showForm }"
      tabindex="-1"
      role="dialog"
    >
      <form v-on:submit.prevent="submit">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <button
                type="button"
                class="close"
                @click="showForm = false"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title">
                {{ Object.keys(item).length > 0 ? "Изменить" : "Добавить" }}
                позицию
              </h4>
            </div>
            <div class="modal-body">
              <div
                class="form-group"
                v-bind:class="{ 'has-error': checkError('UF_NAME') }"
              >
                <label>Наименование<span>*</span></label>
                <input
                  type="text"
                  maxlength="200"
                  class="form-control"
                  v-model="item.UF_NAME"
                />
              </div>
              <div
                class="form-group"
                v-bind:class="{
                  'has-error': checkError('UF_FIRM_MANUFACTURER')
                }"
              >
                <label>Фирма-производитель<span>*</span></label>
                <input
                  type="text"
                  maxlength="200"
                  class="form-control"
                  v-model="item.UF_FIRM_MANUFACTURER"
                />
              </div>
              <div
                class="form-group"
                v-bind:class="{
                  'has-error': checkError('UF_COUNTRY_ORIGIN_ID')
                }"
              >
                <label>Страна происхождения<span>*</span></label>
                <select
                  v-model="item.UF_COUNTRY_ORIGIN_ID"
                  class="form-control"
                >
                  <option
                    v-for="item in directory.country"
                    v-bind:value="item.ID"
                    v-bind:key="item.ID"
                    v-text="item.NAME"
                  ></option>
                </select>
              </div>
              <div
                class="form-group"
                v-bind:class="{
                  'has-error': checkError('UF_FACTORY_IDENTIFICATION_NUMB')
                }"
              >
                <label
                  >Заводской или иной идентификационный номер<span
                    >*</span
                  ></label
                >
                <input
                  type="text"
                  maxlength="200"
                  class="form-control"
                  v-model="item.UF_FACTORY_IDENTIFICATION_NUMB"
                />
              </div>
              <div
                class="form-group"
                v-bind:class="{ 'has-error': checkError('UF_COUNT') }"
              >
                <label>Количество<span>*</span></label>
                <div class="clear"></div>
                <input
                  type="text"
                  class="form-control"
                  v-model="item.UF_COUNT"
                  @keypress="isNumber($event)"
                />
              </div>
              <div
                class="form-group"
                v-bind:class="{ 'has-error': checkError('UF_PRICE_UNIT') }"
              >
                <label
                  >Цена за единицу, руб., в том числе НДС<span>*</span></label
                >
                <!--<input
                  type="text"
                  maxlength="200"
                  class="form-control"
                  v-model="item.UF_PRICE_UNIT"
                  @keypress="isNumber($event)"
                />-->
                <vue-numeric
                  separator="space"
                  :precision="2"
                  type="text"
                  class="form-control"
                  v-model="item.UF_PRICE_UNIT"
                  v-on:keypress.native="isFloat($event)"
                />
              </div>
              <button type="button" @click="submit" class="btn btn-info">
                Сохранить
              </button>
              <button
                type="button"
                @click="showForm = false"
                class="btn btn-default"
              >
                Отмена
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { FETCH_DIRECTORY } from "@/store/actions.type";
import { mapGetters } from "vuex";

export default {
  name: "EquipmentBuyLizing",
  data() {
    return {
      showForm: false,
      editIndex: -1,
      item: {},
      errorFields: {}
    };
  },
  created() {
    this.$store.dispatch(FETCH_DIRECTORY, ["country"]);
  },
  computed: {
    ...mapGetters(["directory"])
  },
  methods: {
    showAddItem() {
      this.setError("");
      this.showForm = true;
      this.editIndex = -1;
      this.item = {};
    },
    editItem(index) {
      this.setError("");
      this.editIndex = index;
      this.item = JSON.parse(
        JSON.stringify(this.$parent.project.EQUIPMENT_BUY_LIZING.items[index])
      );
      this.showForm = true;
    },
    deleteItem(index) {
      this.$parent.project.EQUIPMENT_BUY_LIZING.items.splice(index, 1);
    },
    submit() {
      this.setError("");
      if (!this.item.UF_NAME) {
        this.setError("UF_NAME");
      }
      if (!this.item.UF_FIRM_MANUFACTURER) {
        this.setError("UF_FIRM_MANUFACTURER");
      }
      if (!this.item.UF_COUNTRY_ORIGIN_ID) {
        this.setError("UF_COUNTRY_ORIGIN_ID");
      }
      if (!this.item.UF_FACTORY_IDENTIFICATION_NUMB) {
        this.setError("UF_FACTORY_IDENTIFICATION_NUMB");
      }
      if (!this.item.UF_COUNT) {
        this.setError("UF_COUNT");
      }
      if (!this.item.UF_PRICE_UNIT) {
        this.setError("UF_PRICE_UNIT");
      }
      console.log(Object.keys(this.errorFields));
      if (Object.keys(this.errorFields).length) {
        return;
      }
      if (this.editIndex > -1) {
        this.$parent.project.EQUIPMENT_BUY_LIZING.items[
          this.editIndex
        ] = JSON.parse(JSON.stringify(this.item));
      } else {
        this.$parent.project.EQUIPMENT_BUY_LIZING.items.push(this.item);
      }
      this.showForm = false;
      return false;
    },
    isNumber(evt) {
      evt = evt ? evt : window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    isFloat(evt) {
      evt = evt ? evt : window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      //console.log("charCode = " + charCode);
      //if (charCode === 46) {return true; } //.
      if (charCode === 44) {
        //,
        return true;
      }

      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    setError(field, val) {
      if (!field) {
        this.errorFields = {};
        return;
      }
      this.errorFields[field] = val ? val : true;
    },
    checkError(field) {
      if (this.errorFields[field]) {
        return true;
      }
      return false;
    },
    countryName(item) {
      const result = this.directory.country.filter(c => c.ID === item);
      return result[0].NAME;
    },
    countEntChar(value, limit) {
      if (value) {
        return value.length > limit ? 0 : limit - value.length;
      }
      return limit;
    }
  }
};
</script>

<style scoped></style>
